import type { PolicyMetaData } from "@/core/types";
import type { AptiRequestConfig } from "@/lib/types/api";

import { http } from "../utils/axios";

export const publicRequestsTyped = {
  get_policy_metadata: function (): Promise<PolicyMetaData> {
    const config = {
      method: "GET",
      url: "/v1/public/get_policy_metadata",
    } satisfies AptiRequestConfig;

    // casting is necessary until we add types higher up to the client
    return http(config) as unknown as Promise<PolicyMetaData>;
  },
};
